import { Context } from "./core/context";
import {
  Box3,
  Color,
  Matrix4,
  Material,
  MeshPhongMaterial,
  Mesh,
  Vector3,
  Vector2,
  TextureLoader,
  SpriteMaterial,
  Sphere,
  BufferGeometry,
  BufferAttribute,
  Uint32BufferAttribute,
  Box3Helper,
  Quaternion,
} from "three";
import { LoadManager } from "./manager/LoaderManager";
import { SceneManager } from "./manager/SceneManager";
import { ViewManager } from "./manager/ViewManager";
import { SelectionManager } from "./manager/SelectionManager";
import { ModelManager } from "./manager/ModelManager";
import { MaterialManager } from "./manager/MaterialManager";
import { ModifyManager } from "./manager/ModifyManager";
import { DbLine } from "./core/DbLine";
import { DbMesh } from "./core/DbMesh";
import { DBEntity } from "./core/DBEntity";
import { DbLayer } from "./core/DbLayer";
import { CameraControls } from "./Controls/CameraControls";
import { DrawManager } from "./manager/DrawManager";
import { DrawOperateState, IDrawOperation } from "./draws/IDrawOperation";
import { DrawOperationLine } from "./draws/DrawOperationLine";
export { FMathUtils } from "./utils/FMathUtils";
export { generateUUID } from "three/src/math/MathUtils";
export { Matrix4 } from "three";
export { SelectionBox } from "./core/SelectionBox";
// let context:Context;
class CadEngine {
  private context!: Context;
  /**
   * 加载器，提供加载不同文件接口
   */

  public get LoadManager(): LoadManager {
    return this.context.LoadManager;
  }

  constructor(container: HTMLDivElement) {
    this.context = new Context({ div: container });
  }
  LoadModel(model: IModelInfo) {
    this.LoadManager.LoadModel(model);
  }

  public get SceneManager() {
    return this.context.SceneManager;
  }

  public get ViewManager() {
    return this.context.ViewManager;
  }
  public get SelectionManager() {
    return this.context.SelectionManager;
  }
  public get ModelManager() {
    return this.context.ModelManager;
  }
  public get DrawManager() {
    return this.context.DrawManager;
  }
  public get ModifyManager() {
    return this.context.ModifyManager;
  }
  public get ToolsManager() {
    return this.context.ToolsManager;
  }
  public set SetWasmObj(obj: any) {
    this.context.wasmObj = obj;
  }
  public set SetWasmAuxiliaryObj(obj: any) {
    this.context.auxiliaryObj = obj;
  }
}

class IBPCad3DEngined {
  private context!: Context;
  public get LoadManager(): LoadManager {
    return this.context.LoadManager;
  }
  constructor(container: HTMLDivElement) {
    this.context = new Context({ div: container });
  }
  public get SceneManager() {
    return this.context.SceneManager;
  }
  public get ViewManager() {
    return this.context.ViewManager;
  }
  public get SelectionManager() {
    return this.context.SelectionManager;
  }
  public get ModelManager() {
    return this.context.ModelManager;
  }
}

export {
  LoadManager,
  SceneManager,
  ViewManager,
  SelectionManager,
  ModelManager,
  MaterialManager,
  CameraControls,
  DrawManager,
  ModifyManager,
};
export { DbLine, DbMesh, DBEntity, DbLayer };
export { IDrawOperation, DrawOperationLine, DrawOperateState };
export {
  Box3,
  MeshPhongMaterial,
  Box3Helper,
  Material,
  Color,
  Mesh,
  Vector3,
  Vector2,
  TextureLoader,
  SpriteMaterial,
  Sphere,
  BufferGeometry,
  BufferAttribute,
  Uint32BufferAttribute,
  Quaternion,
};

export { CadEngine };

export { IBPCad3DEngined };

// alert("sds");
